export function resolvePaymentDestination(provider, search = '') {
  if (provider === 'PhonePe') return null;
  if (provider === 'Razorpay') {
    return {
      pathname: '/payment/razorpay',
      search,
    };
  }
  throw new Error('Unsupported payment gateway.');
}
